import React from 'react';
import { VouchLogo } from '../components/VouchLogo';

// Same-origin iframes share sessionStorage with the parent page,
// so auth propagates automatically — no need to pass key in URL.
// demo_role is needed for Supabase storage key isolation per persona.
const PANES = [
  {
    label: 'Tom McCotter — Candidate',
    path: '/candidate?demo_role=candidate',
    color: '#18B6B2', // Teal
  },
  {
    label: 'Tracey McCotter — Voucher',
    path: '/voucher?demo_role=voucher',
    color: '#059669', // Emerald
  },
  {
    label: 'Kevin Lemieux — Hiring Manager',
    path: '/hiring-manager?demo_role=hm',
    color: '#0B1F3B', // Navy
  },
];

const HEADER_HEIGHT = 56;

export default function DemoPage() {
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', background: '#f3f4f6' }}>
      {/* Header */}
      <div
        style={{
          height: HEADER_HEIGHT,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0 20px',
          background: '#0B1F3B',
          flexShrink: 0,
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <VouchLogo height={28} />
          <span style={{ color: '#fff', fontSize: 16, fontWeight: 600, opacity: 0.85 }}>
            Demo Dashboard
          </span>
        </div>
        <a
          href="/admin"
          style={{ color: '#18B6B2', fontSize: 14, textDecoration: 'none', fontWeight: 500 }}
        >
          Admin &rarr;
        </a>
      </div>

      {/* 3-column grid */}
      <div
        style={{
          flex: 1,
          display: 'grid',
          gridTemplateColumns: 'repeat(3, minmax(320px, 420px))',
          gridTemplateRows: '1fr',
          gap: 16,
          overflowX: 'auto',
          justifyContent: 'center',
          padding: '16px 24px',
          minHeight: 0,
        }}
      >
        {PANES.map(({ label, path, color }) => (
          <div key={path} style={{ display: 'flex', flexDirection: 'column', minWidth: 0, minHeight: 0, borderRadius: 12, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0,0,0,0.15)' }}>
            {/* Column header */}
            <div
              style={{
                height: 36,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: color,
                color: '#fff',
                fontSize: 13,
                fontWeight: 600,
                letterSpacing: 0.3,
                flexShrink: 0,
              }}
            >
              {label}
            </div>
            {/* iframe */}
            <iframe
              src={path}
              title={label}
              style={{
                flex: 1,
                width: '100%',
                border: 'none',
                background: '#fff',
                minHeight: 0,
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
